import CustomModalFooter from 'components/Custom/CustomModalFooter'
import CustomModalHeader from 'components/Custom/CustomModalHeader'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Modal, ModalBody, Nav, NavItem, NavLink } from 'reactstrap'
import { sendWelcomeEmailToAllUsers } from 'store/Users/actions'
import AssignTabs from '../AssignTabs'
import AxiosInstance from 'utils/AxiosInstance'
import { toggleOrgGroups } from 'store/Users/actions'
import { toggleUsers } from 'store/Users/actions'
import { toggleLocationGroups } from 'store/Users/actions'
import { toggleStores } from 'store/Users/actions'
import { toggleRoles } from 'store/Library/actions'
import { setHideSelectedOrgGroups } from 'store/Users/actions'
import { setHideSelectedLocationGroups } from 'store/Users/actions'
import { setHideSelectedLocations } from 'store/Users/actions'
import { setHideSelectedRoles } from 'store/Users/actions'
import { setHideSelectedStores } from 'store/Users/actions'
import { setHideSelectedUsers } from 'store/Users/actions'
import { setShowSelectedOrgGroups } from 'store/Users/actions'
import { setShowSelectedUsers } from 'store/Users/actions'
import { setShowSelectedStores } from 'store/Users/actions'
import { setShowSelectedRoles } from 'store/Users/actions'
import { setShowSelectedLocations } from 'store/Users/actions'
import { setShowSelectedLocationGroups } from 'store/Users/actions'
import { useSelector } from 'react-redux'
import { fetchGroups } from 'store/Group/actions'
import { fetchRoles } from 'store/Group/actions'
import { resetSelectedItems } from 'store/Users/actions'
import { setCurrentTab } from 'store/Users/actions'
import { setAssignSearchValue } from 'store/Users/actions'
import TextEditor from '../TextEditor'
import { onChangeEmailBody } from 'store/Users/actions'
import { onChangeEmailSubject } from 'store/Users/actions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy, faLightbulb } from '@fortawesome/free-solid-svg-icons'
import Hints from '../UIElements/Hints'
import { onChangeWelcomeEmailSubject } from 'store/Users/actions'
import { onChangeWelcomeEmailBody } from 'store/Users/actions'
import NotLoggedInUsers from './NotLoggedInUsers'
import { getNotLoggedInUsers } from 'store/Users/actions'
import { fetchWelcomeEmailTemplate } from 'store/Users/actions'
import { saveWelcomeEmailTemplate } from 'store/Users/actions'

function WelcomeEmailModal({
  userAccess,
  setShowSendWelcomeModal,
  showSendWelcomeModal,
  users,
}) {
  const dispatch = useDispatch()
  const groups = useSelector((state) => state.groups)
  const [emailType, setEmailType] = useState('welcome')
  const [selection, setSelection] = useState('automatic')
  const [sendAsWelcome, setSendAsWelcome] = useState(false)
  const [sendingEmail, setSendingEmail] = useState(false)
  const [showSnippets, setShowSnippets] = useState(false)
  const [savingTemplate, setSavingTemplate] = useState(false)

  const [groupOrgs, setGroupOrgs] = useState([])
  const [soters, setStores] = useState([])

  const languageRedux = useSelector((state) => state.language?.language?.data)

  const language = languageRedux || {}

  console.log(language?.settings, 'leart62')

  const items = {
    groupOrgs: groupOrgs,
    users: users.usersExtendedDetails,
    stores: soters,
    locationGroups: groups.locationGroups,
    roles: groups.roles,
  }

  const onAddChange = (property, value) => {
    dispatch(onChangeEmailBody(property, value))
  }

  const onAddChangeWelcomeBody = (property, value) => {
    dispatch(onChangeWelcomeEmailBody(property, value))
  }

  const changeEmailType = () => {
    if (emailType === 'welcome') {
      setEmailType('custom')
    } else {
      setEmailType('welcome')
    }
  }

  const changeSelectionType = () => {
    if (selection === 'automatic') {
      setSelection('manual')
    } else {
      setSelection('automatic')
    }
  }

  const fetchOrgGroups = () => {
    AxiosInstance.get(`/groups/orgs`).then((data) => setGroupOrgs(data))
  }

  const fetchStores = async () => {
    await AxiosInstance.get(`/stores`).then((stores) => {
      const formatedStores = []

      if (Array.isArray(stores)) {
        stores.map((item) => {
          formatedStores.push({
            ...item,
            status: item.status === 'Active' ? true : false,
          })
        })
      }

      setStores(formatedStores)
    })
  }

  useEffect(() => {
    fetchOrgGroups()
    fetchStores()
    dispatch(fetchGroups())
    dispatch(fetchRoles())
    dispatch(getNotLoggedInUsers())
    dispatch(fetchWelcomeEmailTemplate())
  }, [dispatch])

  useEffect(() => {
    if (showSendWelcomeModal) {
      setSendingEmail(false)
    }
  }, [showSendWelcomeModal])

  const toggleTabs = {
    toggleOrgGroups,
    toggleUsers,
    toggleLocationGroups,
    toggleStores,
    toggleRoles,
  }

  const hideSelectFunctions = {
    setHideSelectedOrgGroups,
    setHideSelectedLocationGroups,
    setHideSelectedLocations,
    setHideSelectedRoles,
    setHideSelectedStores,
    setHideSelectedUsers,
  }

  const showSelectFunctions = {
    setShowSelectedOrgGroups,
    setShowSelectedUsers,
    setShowSelectedStores,
    setShowSelectedRoles,
    setShowSelectedLocations,
    setShowSelectedLocationGroups,
  }

  return (
    <Modal
      toggle={() => setShowSendWelcomeModal(false)}
      isOpen={showSendWelcomeModal}
      centered
      size='xl'
    >
      <CustomModalHeader
        title='Send email'
        toggle={() => setShowSendWelcomeModal(false)}
      />
      <ModalBody>
        <div className='d-flex'>
          <div className='mr-3'>
            <input
              type='radio'
              checked={emailType === 'welcome'}
              onChange={changeEmailType}
              className='my-2'
              value={'welcomeEmail'}
              id={'welcomeEmail'}
            />
            <label className='m-2' htmlFor={'welcomeEmail'}>
              Welcome email
            </label>
          </div>
          <div className=''>
            <input
              type='radio'
              checked={emailType === 'custom'}
              onChange={changeEmailType}
              className='my-2'
              value={'customEmail'}
              id={'customEmail'}
            />
            <label className='m-2' htmlFor={'customEmail'}>
              New email
            </label>
          </div>
        </div>
        <div className='ml-auto'>
          <button
            onClick={() => setShowSnippets(!showSnippets)}
            className=' btn btn-secondary'
          >
            <FontAwesomeIcon icon={faLightbulb} /> Snippets
          </button>
          {showSnippets && (
            <div className='mt-3'>
              <div className='d-flex align-content-center'>
                <p>[firstname]</p>
                <p
                  role='button'
                  className='mx-3'
                  title='Copy to clipboard'
                  onClick={() => navigator.clipboard.writeText(`[firstname]`)}
                >
                  <FontAwesomeIcon icon={faCopy} />
                </p>
                <p className='ml-auto'>
                  <Hints message='First name of the recipient' />
                </p>
              </div>

              <div className='d-flex align-content-center'>
                <p>[lastname]</p>
                <p
                  role='button'
                  className='mx-3'
                  title='Copy to clipboard'
                  onClick={() => navigator.clipboard.writeText(`[lastname]`)}
                >
                  <FontAwesomeIcon icon={faCopy} />
                </p>
                <p className='ml-auto'>
                  <Hints message='Last name of the recipient' />
                </p>
              </div>
              <div className='d-flex align-content-center'>
                <p>[academyname]</p>
                <p
                  role='button'
                  className='mx-3'
                  title='Copy to clipboard'
                  onClick={() => navigator.clipboard.writeText(`[academyname]`)}
                >
                  <FontAwesomeIcon icon={faCopy} />
                </p>
                <p className='ml-auto'>
                  <Hints message="Academy's name" />
                </p>
              </div>
              <div className='d-flex align-content-center'>
                <p>{`[course_id]`}</p>
                <p
                  role='button'
                  className='mx-3'
                  title='Copy to clipboard'
                  onClick={() => navigator.clipboard.writeText(`[course_id]`)}
                >
                  <FontAwesomeIcon icon={faCopy} />
                </p>
                <p className='ml-auto'>
                  <Hints message="Course's name. Replace <id> with an actual existing course id" />
                </p>
              </div>
              <div className='d-flex align-content-center'>
                <p>[login_link]</p>
                <p
                  role='button'
                  className='mx-3'
                  title='Copy to clipboard'
                  onClick={() => navigator.clipboard.writeText(`[login_link]`)}
                >
                  <FontAwesomeIcon icon={faCopy} />
                </p>
                <p className='ml-auto'>
                  <Hints message="Your academy's login url" />
                </p>
              </div>
              <div className='d-flex align-content-center'>
                <p>[default_password]</p>
                <p
                  role='button'
                  className='mx-3'
                  title='Copy to clipboard'
                  onClick={() =>
                    navigator.clipboard.writeText(`[default_password]`)
                  }
                >
                  <FontAwesomeIcon icon={faCopy} />
                </p>
                <p className='ml-auto'>
                  <Hints message='Default password of your academy. You cannot change this value here! Do not remove this if you want your users to be able to see their password in the welcome email.' />
                </p>
              </div>
            </div>
          )}
        </div>
        {emailType === 'custom' ? (
          <>
            <input
              value={users?.subject || ''}
              placeholder='Email Subject'
              className='w-100 p-2 my-3'
              style={{ border: '1px solid #cecece' }}
              type='text'
              onChange={(e) => dispatch(onChangeEmailSubject(e.target.value))}
            />
            <TextEditor
              key={1}
              placeholder='Email Body'
              isOpen={users.isShowingEditMessage}
              textContent={users.body}
              onChangeText={(e) => onAddChange(e)}
            />
          </>
        ) : (
          <>
            <input
              value={users?.welcomeSubject || ''}
              id='welcomeSubject'
              placeholder='Email Subject'
              className='w-100 p-2 my-3'
              style={{ border: '1px solid #cecece' }}
              type='text'
              onChange={(e) =>
                dispatch(onChangeWelcomeEmailSubject(e.target.value))
              }
            />
            <TextEditor
              key={2}
              placeholder='Email Body'
              isOpen={users.isShowingEditMessage}
              textContent={users.welcomeBody}
              onChangeText={(e) => onAddChangeWelcomeBody(e)}
            />
            <div className='d-flex justify-content-end mt-3'>
              <button
                className='btn btn-secondary'
                disabled={savingTemplate}
                onClick={() =>
                  dispatch(saveWelcomeEmailTemplate(setSavingTemplate))
                }
              >
                {savingTemplate ? 'Saving Template...' : 'Save as Template'}
              </button>
            </div>
          </>
        )}

        {emailType === 'welcome' && (
          <div className='d-flex'>
            <div className='mr-3'>
              <input
                type='radio'
                checked={selection === 'automatic'}
                onChange={changeSelectionType}
                className='my-2'
                value={'automatic'}
                id={'automatic'}
              />
              <label className='m-2' htmlFor={'automatic'}>
                Automatic User Selection
                <Hints message='Users who haven’t logged in or shown any activity will be selected automatically.' />
              </label>
            </div>
            <div className=''>
              <input
                type='radio'
                checked={selection === 'manual'}
                onChange={changeSelectionType}
                className='my-2'
                value={'manual'}
                id={'manual'}
              />
              <label className='m-2' htmlFor={'manual'}>
                Manual Selection
              </label>
            </div>
          </div>
        )}

        {emailType === 'welcome' && selection === 'automatic' ? (
          <NotLoggedInUsers />
        ) : (
          <div className='d-flex flex-column align-items-start'>
            <div className='nav-wrapper col-12'>
              <Nav
                className='nav-fill flex-column flex-sm-row col-12 p-2 rounded '
                id='tabs-text'
                style={{ backgroundColor: '#f6f9fc' }}
                pills
                role='tablist'
              >
                <NavItem className='nav-items'>
                  <NavLink
                    aria-selected={users.currentTab === 'category'}
                    className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
																${users.currentTab === 'category' ? 'active-item' : 'nav-item'}`}
                    onClick={(e) =>
                      dispatch(
                        setCurrentTab(
                          e,
                          'category',
                          'selectedOrgGroups',
                          'groupOrgs',
                          'toggleOrgGroups',
                          'showSelectedOrgGroups',
                          'setShowSelectedOrgGroups',
                          'setHideSelectedOrgGroups',
                        ),
                      )
                    }
                    href='#pablo'
                    role='tab'
                    size='sm'
                  >
                    {language.general ? language.general.category : 'Category'}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    aria-selected={users.currentTab === 'user'}
                    className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
													${users.currentTab === 'user' ? 'active-item' : 'nav-item'}`}
                    onClick={(e) =>
                      dispatch(
                        setCurrentTab(
                          e,
                          'user',
                          'selectedUsers',
                          'users',
                          'toggleUsers',
                          'showSelectedUsers',
                          'setShowSelectedUsers',
                          'setHideSelectedUsers',
                        ),
                      )
                    }
                    href='#pablo'
                    role='tab'
                    color='none'
                  >
                    {language.general ? language.general.users : 'Users'}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    aria-selected={users.currentTab === 'location-group'}
                    className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
																${users.currentTab === 'location-group' ? 'active-item' : 'nav-item'}`}
                    onClick={(e) =>
                      dispatch(
                        setCurrentTab(
                          e,
                          'location-group',
                          'selectedLocationGroups',
                          'locationGroups',
                          'toggleLocationGroups',
                          'showSelectedLocationGroups',
                          'setShowSelectedLocationGroups',
                          'setHideSelectedLocationGroups',
                        ),
                      )
                    }
                    href='#pablo'
                    role='tab'
                  >
                    {language.general
                      ? language.general.location_categories
                      : 'Location Groups'}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    aria-selected={users.currentTab === 'stores'}
                    className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
													${users.currentTab === 'stores' ? 'active-item' : 'nav-item'}`}
                    onClick={(e) =>
                      dispatch(
                        setCurrentTab(
                          e,
                          'stores',
                          'selectedStores',
                          'stores',
                          'toggleStores',
                          'showSelectedStores',
                          'setShowSelectedStores',
                          'setHideSelectedStores',
                        ),
                      )
                    }
                    href='#pablo'
                    role='tab'
                  >
                    {language.settings
                      ? language.settings.location
                      : 'Location'}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    aria-selected={users.currentTab === 'job-title'}
                    className={`mb-sm-3 mb-md-0 py-1 text-dark bg-transparent font-weight-bold 
																${users.currentTab === 'job-title' ? 'active-item' : 'nav-item'}`}
                    onClick={(e) =>
                      dispatch(
                        setCurrentTab(
                          e,
                          'job-title',
                          'selectedRoles',
                          'roles',
                          'toggleRoles',
                          'showSelectedRoles',
                          'setShowSelectedRoles',
                          'setHideSelectedRoles',
                        ),
                      )
                    }
                    href='#pablo'
                    role='tab'
                  >
                    {language.settings
                      ? language.settings.assign_job_title
                      : 'Job Title'}
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
            <AssignTabs
              items={items[users.currentItems]}
              toggleItem={toggleTabs[users.currentToggleFunction]}
              selectedItems={users.currentSelectedItems}
              mainProps={users}
              assignSearchValue={users.assignSearchValue}
              setHideSelectedItems={
                hideSelectFunctions[users.currentHideSelectedItemsFunction]
              }
              setShowSelectedItems={
                showSelectFunctions[users.currentShowSelectedItemsFunction]
              }
              showSelectedItems={users[users.currentShowSelectedItems]}
              // language={props.language}
              resetSelectedItems={resetSelectedItems}
              setCurrentTab={setCurrentTab}
              setAssignSearchValue={setAssignSearchValue}
              enableCategories={true}
              resetModal={users.toggleModal}
            />
          </div>
        )}
      </ModalBody>
      <CustomModalFooter>
        <SubmitModalButton
          customFn={() =>
            dispatch(
              sendWelcomeEmailToAllUsers(
                emailType,
                selection,
                setShowSendWelcomeModal,
                setSendingEmail,
              ),
            )
          }
          text={
            sendingEmail
              ? 'Sending Email...'
              : emailType === 'welcome'
                ? 'Send Welcome Email'
                : 'Send Email'
          }
        />
      </CustomModalFooter>
    </Modal>
  )
}

export default WelcomeEmailModal
